export default [
  {
    path: '/products/properties',
    name: 'properties',
    component: () => import('../pages/products/properties/properties.shell.vue'),
  },
  {
    path: '/products/properties/:propertyId/contracts',
    name: 'property-contracts',
    component: () => import('../pages/products/property-contracts/property-contracts.shell.vue'),
  },
  {
    path: '/products/properties/:propertyId/widgets',
    name: 'property-widgets',
    component: () => import('../pages/products/property-widgets/property-widgets.shell.vue'),
  },
  {
    path: '/products/cancellation-insurances',
    name: 'cancellation-insurances',
    component: () => import('../pages/products/cancellation-insurances/cancellation-insurances.shell.vue'),
  },
];
